import Header from "./Header";
import Footer from "./Footer";

function Branding() {
    return (
        <>
            <Header />

            <div className="mil-soft-bg">

                {/* Banner */}
                <div className="mil-inner-banner">
                    <div className="container mil-p-120-120">
                        <ul className="mil-breadcrumbs mil-mb-60">

                            <li><a href="/">Home</a></li>
                            <li><a href="/services">Services</a></li>
                            <li><span>Branding & Identity Design</span></li>
                        </ul>

                        <h1 className="mil-mb-60">
                            Branding <br />
                            <span className="mil-thin">& Identity Design</span>
                        </h1>
                        <a href="#content" className="mil-link mil-arrow-place">
                            <span>About service</span>
                        </a>
                    </div>
                </div>

                {/* Content Section */}
                <section>
                    <div className="container mil-p-120-120">
                        <div className="row">

                            <div className="col-lg-4">
                                <h4>Your Approach <br />and Work Specifics</h4>

                                <p className="mil-mt-30">
                                    We build brands from the inside out—
                                    combining strategy, research, and design
                                    to create identities that communicate
                                    purpose, build trust, and drive recognition.
                                </p>
                            </div>

                            <div className="col-lg-8">

                                <div className="mil-service-list">

                                    <div className="mil-service-item">
                                        Brand Strategy & Positioning
                                    </div>

                                    <div className="mil-service-item">
                                        Logo Design & Visual Identity
                                    </div>

                                    <div className="mil-service-item">
                                        Brand Guidelines & Playbooks
                                    </div>

                                    <div className="mil-service-item">
                                        Packaging & Label Design
                                    </div>

                                    <div className="mil-service-item">
                                        Rebranding & Brand Refresh
                                    </div>

                                    <div className="mil-service-item">
                                        Naming & Brand Architecture
                                    </div>

                                </div>

                            </div>

                        </div>
                    </div>
                </section>

            </div>

            <Footer />
        </>
    );
}

export default Branding;